import { Component, OnInit, EventEmitter, Output, OnDestroy, Inject } from "@angular/core";
import { ConfigInterface, CONFIG_OPTIONS } from "@libs/config/config-options";
import { FactoryService } from "@services/common/factory.service";
import { CommonService } from "@services/common/common.service";
import { ApiLibs } from '@libs/config/api-library';
import ProfileCaptcha from "@shdr/profile-captcha";
import { Subscription } from "rxjs";

@Component({
    standalone: false,
    selector: "com-captcha",
    template: '',
    styleUrls: ['./com-captcha.component.scss']
})
export class ComCaptchaComponent implements OnInit, OnDestroy{
  @Output() passEmit = new EventEmitter();
  @Output() limitEmit = new EventEmitter();

  private triggerCaptchaSub: Subscription;
  private curCaptcha: ProfileCaptcha = null;
  private language: string;
  private pinType: string;
  private resendPin: boolean;
  private logined: boolean;

  constructor(
    private factorySer: FactoryService,
    private comSer: CommonService,
    @Inject(CONFIG_OPTIONS) private config: ConfigInterface,
  ) { }
  
  async ngOnInit() {
    this.language = await this.factorySer.getLanguage();
    this.triggerCaptchaSub = this.comSer.triggerCaptchaSub.subscribe((resp) => {
      this.comSer.refreshLoading(false);
      // 首次调用captcha, 或上次调用接口超时未成功
      if (resp && (!this.curCaptcha || (this.curCaptcha && this.curCaptcha.getCaptchaInstanceApiStatus().getCaptchaApiStatus === 'rejected'))) { 
        this.curCaptcha?.destroyDomAndEventListener();
        this.getCaptcha();
        document.addEventListener("@profile-captcha:verifyCaptchaSuccess", this.passed);
        document.addEventListener("@profile-captcha:limitFlow", this.limitHandler);
        document.addEventListener("@profile-captcha:throwHttpError", this.errhandle);
        document.addEventListener("@profile-captcha:closeCaptcha",this.close);
      } else {
        // 若captcha接口状态为pendding或fulfilled，防止重复请求
        return;
      }
    });
  }
      
  private getCaptcha() {
    const curContainer: HTMLElement | null = document.querySelector(".com-captcha-box");
    const hostN = window.location.hostname;
    const tmpType = hostN === 'localhost' ? 'RANDOM' : 'PROFILE';
    this.pinType = this.factorySer.getPinType();
    this.resendPin = this.factorySer.resendPin;
    
    this.curCaptcha = new ProfileCaptcha({
      mode: "modal",
      servicePrefix: "",
      container: curContainer,
      businessUserDefinedPathMap: {
        getCaptchaPath: this.config.tykCaptchaUrl(`${ApiLibs.getCaptcha}?type=${tmpType}`),
        verifyCaptchaPath: this.config.tykCaptchaUrl(ApiLibs.verifyCaptcha),
        getProfileCaptchaAcpPath: this.config.tykBaseUrl(ApiLibs.getTridionResource)
      },
      limitFlowCodes: [580, 429],
      language: this.language,
      businessCode: this.factorySer.getBusiness(),
      channelCode: this.factorySer.getChannel(),
      trackingEnable: true,
      trackingParams: {
        env: window.env, 
        screen_type: this.getPageScreenInfo(true),
        page_name: this.getPageScreenInfo(),
        entry_point_category: 'profile_related'
      }
    });
    // fix captcha swid track
    const swid = this.factorySer.getSWID();
    if(swid) {
      this.curCaptcha.setTrackingSwid(swid);
    }
  }

  /*
    if sFlag=true get screen_type, else get page_name
    default pinType is ( phonePin || legacyPhonePin || cspPhonePin )
  */
  private getPageScreenInfo(sFlag?: boolean): string { 
    const type = this.resendPin ? 'verification_code' : null;
    const page = this.resendPin ? 'tools/verification/code ' : null;
    let value;
    switch (this.pinType) {
      case 'forgetPwdPhone':
      case 'forgetPwdEmail':
        this.logined = this.factorySer.getLoginStatus();
        value = sFlag ? (this.logined ? 'edit_profile' : 'login') :
          (this.logined ? (this.pinType === 'forgetPwdPhone' ? 'tools/me/edit_profile/change_password/forget_password/mobile' : 'tools/me/edit_profile/change_password/forget_password/email' ) :
            (this.pinType === 'forgetPwdPhone' ? 'tools/login/mobile/password/forget_password/mobile' : 'tools/login/mobile/password/forget_password/email'));
        break;
      case 'forgetPwdEmail':
        this.logined = this.factorySer.getLoginStatus();
        value = sFlag ? (this.logined ? 'edit_profile' : 'login') : (this.logined ? 'tools/me/edit_profile/change_password/forget_password/email' : 'tools/login/mobile/password/forget_password/email');
        break;
      case 'phoneUpdate':
        const flow = this.factorySer.getUpdatePhoneFlow();
        value = sFlag ? 'edit_profile' : (flow === 'edit' ? 'tools/me/edit_profile/update_mobile_number/new_number' : 'tools/me/edit_profile/logout/change_mobile_number');
        break;
      case 'deleteAcct':
        value = sFlag ? 'edit_profile' : 'tools/me/edit_profile/delete_account';
        break;
      default:
        value = sFlag ? 'register_and_login' : 'tools/login/mobile';
        break;
    }
    return sFlag ? (type || value) : (page || value);
  }

  private passed = (res) => {
    const info = {
      capId: res.detail?.capId,
      params: res.detail?.params
    };
    setTimeout(() => {
      this.passEmit.emit(info);
    }, 900);
  }
   
  private limitHandler = (res) => {
    console.log('captcha-limitHandler res..',res);
    const url = res?.detail?.url;
    if(url && url.includes(ApiLibs.getCaptcha)) { // get captcha 
      this.limitEmit.emit();
    } else if(url && url.includes(ApiLibs.verifyCaptcha) && this.curCaptcha) { // verify captcha
      this.curCaptcha?.getCaptcha({
        isInitFlag: false,
        externalCall: true,
        isNeedDomDraw: true
      });
    }
    this.factorySer.setToast(false, '2rem', null, 'Profile.Common.Limit.Toast.API');  
  }

  /**
   * captcha应用调用接口不会被当前应用的http拦截器捕捉，需对captcha接口请求的错误code单独处理
   */
  private errhandle = (res) => {
    console.log('throwHttpError res..', res);
    switch (res?.detail?.code) {
      case 401:
      case 400:
        //accessToken or refreshToken expired
        console.log('http status:', res.detail.code)
        break;
      case 499:
        this.factorySer.errCode = '499';
        this.comSer.showErrorSub.next(true);
        break;
      case 404:
        this.factorySer.errCode = '404-not found';
        this.comSer.showErrorSub.next(true);
        break;
      default:
        this.factorySer.errCode = 'others';
        this.comSer.showErrorSub.next(true);
        break;
    }
    this.comSer.showCaptchaSub.next(false);
  }

  private close = (res) => {
    console.log(res, "@profile-captcha:closeCaptcha");
    this.curCaptcha?.destroyDomAndEventListener();
    // 关闭按钮回调必须将实例重置成null 
    this.curCaptcha = null;
  }
  
  ngOnDestroy() {
    this.curCaptcha?.destroyDomAndEventListener();
    this.triggerCaptchaSub.unsubscribe();
    document.removeEventListener("@profile-captcha:verifyCaptchaSuccess", this.passed);
    document.removeEventListener("@profile-captcha:limitFlow", this.limitHandler);
    document.removeEventListener("@profile-captcha:throwHttpError", this.errhandle);
    document.removeEventListener("@profile-captcha:closeCaptcha", this.close);
    this.curCaptcha = null;
  }

}
  